import React, { Fragment, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { reduxForm, Field } from 'redux-form';
import { ButtonToolbar, Button, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import validate from './Validate';
import renderField from '../../../shared/components/form/RenderField';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';
import Select from '../../../shared/components/form/Select';
import { currencyMasker } from '../../../shared/components/form/Masks';

const ProductForm = (props) => {
  const { t, backHandler, handleSubmit, dto, initialize, category } = props;

  useEffect(() => {
    initialize(dto);
  }, [dto]);

  return (
    <Fragment>
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.name')}</span>
          <div className="form__form-group-field">
            <Field
              name="name"
              type="text"
              component={renderField}
              maxLength="100"
              placeholder={t('product.placeholders.name')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.description')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="description"
              type="text"
              component="textarea"
              maxLength="500"
              placeholder={t('product.placeholders.description')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.category')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="category"
              type="text"
              component={Select}
              options={category}
              placeholder={t('product.placeholders.select')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.value')}</span>
          <div className="form__form-group-field">
            <Field
              name="value"
              type="text"
              component={renderField}
              {...currencyMasker()}
            />
          </div>
        </div>
        <div className="form__form-group">
          <div className="form__form-group-field">
            <Label className="generic__label"> {t('general.active')} </Label>
            <Field
              name="active"
              component={renderCheckBoxField}
              className="colored-click"
            />
          </div>
        </div>
        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.save')}
          </Button>
        </ButtonToolbar>
      </form>
    </Fragment>
  );
};

ProductForm.propTypes = {
  t: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dto: PropTypes.objectOf(PropTypes.shape).isRequired,
  initialize: PropTypes.func.isRequired,
  category: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

export default reduxForm({
  form: 'ProductForm',
  validate,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(withTranslation('common')(ProductForm));
